export const PR_PT = "PR_PT";
export const PR_PPT = "PR_PPT";
export const INOUT_MODE = "INOUT_MODE";
export const INCOMEBENEFITPAYOUTFREQUENCY = "IncomeBenefitPayoutFrequency";
export const PLANOPTION = "PlanOption";
export const PREMIUMBREAKBENEFIT = "PremiumBreakBenefit";

export const ACCRUALOFSURVIVALBENEFIT_1 = "AccrualOfSurvivalBenefit_1";
export const ASB_STARTPOLICYYEAR_1 = "ASB_StartPolicyYear_1";
export const ASB_ENDPOLICYYEAR_1 = "ASB_EndPolicyYear_1";

export const ACCRUALOFSURVIVALBENEFIT_2 = "AccrualOfSurvivalBenefit_2";
export const ASB_STARTPOLICYYEAR_2 = "ASB_StartPolicyYear_2";
export const ASB_ENDPOLICYYEAR_2 = "ASB_EndPolicyYear_2";

export const ACCRUALOFSURVIVALBENEFIT_3 = "AccrualOfSurvivalBenefit_3";
export const ASB_STARTPOLICYYEAR_3 = "ASB_StartPolicyYear_3";
export const ASB_ENDPOLICYYEAR_3 = "ASB_EndPolicyYear_3";

export const PREPONEMENTOFFUTUREINCOME_1 = "PreponementOfFutureIncome_1";
export const PFI_STARTPOLICYYEAR_1 = "PFI_StartPolicyYear_1";
export const PFI_ENDPOLICYYEAR_1 = "PFI_EndPolicyYear_1";

export const PREPONEMENTOFFUTUREINCOME_2 = "PreponementOfFutureIncome_2";
export const PFI_STARTPOLICYYEAR_2 = "PFI_StartPolicyYear_2";
export const PFI_ENDPOLICYYEAR_2 = "PFI_EndPolicyYear_2";

export const PREPONEMENTOFFUTUREINCOME_3 = "PreponementOfFutureIncome_3";
export const PFI_STARTPOLICYYEAR_3 = "PFI_StartPolicyYear_3";
export const PFI_ENDPOLICYYEAR_3 = "PFI_EndPolicyYear_3";

export const AUTORENEWALBOOSTER = "AutoRenewalBooster";
export const PR_SAMF ="PR_SAMF";

export const WOP_RIDER = 'WaiverOfPremiumRider';
export const ADB_RIDER = 'ADBRider';
export const ATPD_RIDER = 'ATPDRider';
export const Critical_ILLNESS_RIDER = 'CriticalIllnessRider';
export const PWB_RIDER = 'PayorWaiverBenefitRider';